import { render, staticRenderFns } from "./ActiveVipOrders.vue?vue&type=template&id=2b74e9d0"
import script from "./ActiveVipOrders.vue?vue&type=script&lang=js"
export * from "./ActiveVipOrders.vue?vue&type=script&lang=js"
import style0 from "./ActiveVipOrders.vue?vue&type=style&index=0&id=2b74e9d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports